// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28zR4","colBig":"styles_colBig__2Y08h","colSmall":"styles_colSmall__2JV5v","shopifyNameWrapper":"styles_shopifyNameWrapper__1VWhy"};